import { Injectable, Injector } from '@angular/core';
import { SynchronizationServiceBase } from './synchronization-service-base';
import { SynchronizationEntity } from './synchronization-entity';
import { ProgrammingRepository } from '../local-db/repositories/programming-repository';

@Injectable({ providedIn: 'root' })
export class ProgrammingSyncService extends SynchronizationServiceBase {
  constructor(
    injector: Injector,
    private readonly _programmingRepository: ProgrammingRepository,
  ) {
    super(injector, SynchronizationEntity.Programmings);
  }

  public async synchronize(): Promise<void> {
    await this._programmingRepository.refreshProgrammings();
  }
}
